module.exports = __webpack_public_path__ + "static/color-wheel1-9f4500e2d716abafe35fbd39348acc7e.png";